import './FieldScore.scss';
class FieldScore {
    constructor( node ) {
        this.node = node;
        this.score = this.getScore();
    }
    init() {
        let t = this;
        let buttons = t.node.querySelectorAll('.row__button');
        buttons.forEach( ( button, index ) => {
            button.addEventListener('click', () => {
                t.score = parseInt( button.getAttribute('data-score') );
                t.setStars( t.score );
            });
            button.addEventListener('mouseenter', () => {
                t.setStars( parseInt( button.getAttribute('data-score') ) );
            });
        });


        t.node.addEventListener('mouseenter', () => {
            t.score = this.getScore();
        });
        t.node.addEventListener('mouseleave', () => {
            t.setStars( t.score );
        });

    }
    getScore() {
        let t = this;
        return parseInt( t.node.querySelectorAll('.row__button.active')[ t.node.querySelectorAll('.row__button.active').length - 1 ].getAttribute('data-score') );
    }
    setStars( index ) {
        let t = this;
        let buttons = t.node.querySelectorAll('.row__button');
        buttons.forEach( ( btn2, index2 ) => {

            if( parseInt( btn2.getAttribute('data-score') ) > index ) {
                btn2.classList.remove('active');
            } else {
                btn2.classList.add('active');
            }

        });
    }
}
JSModules['FieldScore'] = FieldScore;
export default FieldScore;